import { render } from "./P076.vue?vue&type=template&id=8ccf78a0&scoped=true"
import script from "./P076.vue?vue&type=script&lang=js"
export * from "./P076.vue?vue&type=script&lang=js"

import "./P076.vue?vue&type=style&index=0&id=8ccf78a0&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccf78a0"]])

export default __exports__